var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0006 100.286C78.6684 100.286 100.286 78.6684 100.286 52.0006C100.286 25.3331 78.6684 3.71484 52.0006 3.71484C25.3331 3.71484 3.71484 25.3331 3.71484 52.0006C3.71484 78.6684 25.3331 100.286 52.0006 100.286Z",
    stroke: "url(#paint0_linear_1686_70320)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9663 36.0332L34.0332 71.9663",
    stroke: "url(#paint1_linear_1686_70320)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0332 36.0332L69.9663 71.9663",
    stroke: "url(#paint2_linear_1686_70320)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_70320",
    x1: 99.1889,
    y1: 51.209,
    x2: -58.5276,
    y2: 104.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1686_70320",
    x1: 69.558,
    y1: 53.7052,
    x2: 10.8735,
    y2: 73.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1686_70320",
    x1: 69.558,
    y1: 53.7052,
    x2: 10.8735,
    y2: 73.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a9938fb1c713fcc4c12ce18eaa4a2a86.svg";
export { ForwardRef as ReactComponent };